module.exports = __webpack_public_path__ + "img/daniella.9f79b791.webp";